import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '@src/service/axios';
import { toast } from 'react-toastify';
import moment from 'moment';

// Get All Encashment Request
export const getEncashmentRequest = createAsyncThunk('getAllEncashmentData/getEncashmentRequest', async (data) => {
    try {
        let response = await axios.post('/EncashmentRequest/get-request', data, {
            headers: { 'Content-Type': 'application/json' }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

// Get My Encashment Request
export const getMyEncashmentRequest = createAsyncThunk('getAllEncashmentData/getMyEncashmentRequest', async (data) => {
    try {
        let response = await axios.post('/EncashmentRequest/get-my-request', data, {
            headers: { 'Content-Type': 'application/json' }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

// Get Encashment Remark History
export const getEncashmentRequestRemarks = createAsyncThunk('getAllEncashmentData/getEncashmentRequestRemarks', async (id) => {
    try {
        let response = await axios.get('/EncashmentRequest/remarks-history/' + id, {
            headers: { 'Content-Type': 'application/json' }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

// Get Encashment Leave Category Options
export const getEncashmentLeaveCategoryOptions = createAsyncThunk(
    'getAllEncashmentData/getEncashmentLeaveCategoryOptions',
    async (data) => {
        try {
            let response = await axios.get('/EncashmentRequest/leave-category', {
                params: {
                    employeeId: data?.employeeId || data?.empId 
                },
                headers: {
                    'Content-Type': 'application/json',
                    IsAdmin: data?.isAdmin ? data?.isAdmin : false
                }
            });

            return Promise.resolve(response?.data);
        } catch (err) {
            console.log('err', err);
            toast.error(err?.response?.data?.message || 'Something went wrong!');
            return Promise.reject(err);
        }
    }
);

// Get Leave Encash Upto Balance
export const getEncashLeaveUpto = createAsyncThunk('getAllEncashmentData/getEncashLeaveUpto', async (data, { rejectWithValue }) => {
    try {
        const response = await axios.get('/EncashmentRequest/leave-encash-upto', {
            params: {
                EmployeeId: data?.employeeId,
                LeaveCategoryId: data?.leaveCategoryId
            },
            headers: {
                'Content-Type': 'application/json',
                IsAdmin: data?.isAdmin ? data?.isAdmin : false
            }
        });
        return response?.data;
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return rejectWithValue(err?.response?.data);
    }
});

// Create All Encashment Request
export const createEncashmentRequest = createAsyncThunk('getAllEncashmentData/createEncashmentRequest', async (data, { dispatch }) => {
    try {
        let response = await axios.post('/EncashmentRequest', data, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        toast.success(response?.data?.message || 'Encashment request added successfully.');
        await dispatch(
            getEncashmentRequest({
                startDate: moment().startOf('year').format('YYYY-MM-DD'),
                endDate: moment().endOf('year').format('YYYY-MM-DD')
            })
        );
        return Promise.resolve(response);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const createMyEncashmentRequest = createAsyncThunk(
    'getAllEncashmentData/createMyEncashmentRequest',
    async (payload, { dispatch }) => {
        const formData = payload instanceof FormData ? payload : payload?.formData;
        const employeeId = payload instanceof FormData ? null : payload?.employeeId;
        try {
            let response = await axios.post('/EncashmentRequest', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            toast.success(response?.data?.message || 'Encashment request added successfully.');
            if (employeeId) {
                await dispatch(getMyEncashmentRequest({ employeeId }));
            } else {
                await dispatch(getMyEncashmentRequest());
            }
            return Promise.resolve(response);
        } catch (err) {
            toast.error(err?.response?.data?.message || 'Something went wrong!');
            return Promise.reject(err);
        }
    }
);
// Update All Encashment Request
export const updateEncashmentRequest = createAsyncThunk(
    'getAllEncashmentData/updateEncashmentRequest',
    async ({ id, data }, { dispatch }) => {
        try {
            let response = await axios.put(`/EncashmentRequest/${id}`, data, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            toast.success(response?.data?.message || 'Encashment request updated successfully.');
            await dispatch(
                getEncashmentRequest({
                    startDate: moment().startOf('year').format('YYYY-MM-DD'),
                    endDate: moment().endOf('year').format('YYYY-MM-DD')
                })
            );
            return Promise.resolve(response);
        } catch (err) {
            console.log('err', err);
            toast.error(err?.response?.data?.message || 'Something went wrong!');
            return Promise.reject(err);
        }
    }
);

// Update My Encashment Request
export const updateMyEncashmentRequest = createAsyncThunk(
    'getAllEncashmentData/updateMyEncashmentRequest',
    async ({ id, data, employeeId }, { dispatch }) => {
        try {
            let response = await axios.put(`/EncashmentRequest/${id}`, data, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            toast.success(response?.data?.message || 'Encashment request updated successfully.');
            if (employeeId) {
                await dispatch(getMyEncashmentRequest({ employeeId }));
            } else {
                await dispatch(getMyEncashmentRequest());
            }
            return Promise.resolve(response);
        } catch (err) {
            console.log('err', err);
            toast.error(err?.response?.data?.message || 'Something went wrong!');
            return Promise.reject(err);
        }
    }
);

// Update Encashment Request Status (Approve / Reject)
export const updateEncashmentChangeRemarks = createAsyncThunk(
    'getAllEncashmentData/updateEncashmentChangeRemarks',
    async (data, { dispatch }) => {
        try {
            let response = await axios.put('/EncashmentRequest/request-status/' + data?.id, data?.data, {
                headers: { 'Content-Type': 'application/json' }
            });
            toast.success(response?.data?.message || 'Remarks updated successfully.');
            await dispatch(
                getEncashmentRequest({
                    startDate: moment().startOf('year').format('YYYY-MM-DD'),
                    endDate: moment().endOf('year').format('YYYY-MM-DD')
                })
            );
            return Promise.resolve(response?.data);
        } catch (err) {
            console.log('err', err);
            toast.error(err?.response?.data?.message || 'Something went wrong!');
            return Promise.reject(err);
        }
    }
);

export const updateEncashmentBulkChangeRemarks = createAsyncThunk(
    'getAllEncashmentData/updateEncashmentBulkChangeRemarks',
    async (data, { dispatch }) => {
        try {
            let response = await axios.put('/EncashmentRequest/bulk-request-status', data?.data, {
                headers: { 'Content-Type': 'application/json' }
            });

            await dispatch(
                getEncashmentRequest({
                    startDate: moment().startOf('year').format('YYYY-MM-DD'),
                    endDate: moment().endOf('year').format('YYYY-MM-DD')
                })
            );
            toast.success(response?.data?.message || 'Bulk status updated successfully.');
            return Promise.resolve(response?.data);
        } catch (err) {
            console.log('err', err);
            toast.error(err?.response?.data?.message || 'Something went wrong!');
            return Promise.reject(err);
        }
    }
);
// Delete All Encashment Request
export const deleteEncashmentRequest = createAsyncThunk('getAllEncashmentData/deleteEncashmentRequest', async (deleteId, { dispatch }) => {
    try {
        let response = await axios.delete(`/EncashmentRequest/${deleteId}`, {
            headers: { 'Content-Type': 'application/json' }
        });
        toast.success(response?.data?.message || 'Encashment request deleted successfully.');
        await dispatch(
            getEncashmentRequest({
                startDate: moment().startOf('year').format('YYYY-MM-DD'),
                endDate: moment().endOf('year').format('YYYY-MM-DD')
            })
        );
        return Promise.resolve(response);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

// Delete My Encashment Request
export const deleteMyEncashmentRequest = createAsyncThunk(
    'getAllEncashmentData/deleteMyEncashmentRequest',
    async (deleteId, { dispatch }) => {
        try {
            let response = await axios.delete(`/EncashmentRequest/${deleteId}`, {
                headers: { 'Content-Type': 'application/json' }
            });
            toast.success(response?.data?.message || 'Encashment request deleted successfully.');
            await dispatch(getMyEncashmentRequest());
            return Promise.resolve(response);
        } catch (err) {
            console.log('err', err);
            toast.error(err?.response?.data?.message || 'Something went wrong!');
            return Promise.reject(err);
        }
    }
);

export const encashmentSlice = createSlice({
    name: 'getAllEncashmentData',
    initialState: {
        encashment: [],
        myEncashment: [],
        encashmentRemarks: [],
        leaveCategoryOptions: [],
        leaveBalance: {}
    },
    reducers: {
        removeEncashment: (state) => {
            state.encashment = [];
        },
        removeMyEncashment: (state) => {
            state.myEncashment = [];
        },
        clearLeaveCategoryOptions: (state) => {
            state.leaveCategoryOptions = [];
        },
        clearLeaveBalance: (state) => {
            state.leaveBalance = null;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getEncashmentRequest.fulfilled, (state, action) => {
            state.encashment = action?.payload;
            return;
        });
        builder.addCase(getMyEncashmentRequest.fulfilled, (state, action) => {
            state.myEncashment = action?.payload;
            return;
        });
        builder.addCase(getEncashmentRequestRemarks.fulfilled, (state, action) => {
            state.encashmentRemarks = action?.payload;
            return;
        });
        builder.addCase(getEncashmentLeaveCategoryOptions.fulfilled, (state, action) => {
            state.leaveCategoryOptions = action?.payload;
            return;
        });
        builder.addCase(getEncashLeaveUpto.fulfilled, (state, action) => {
            state.leaveBalance = action?.payload;
            return;
        });
    }
});

export const { removeEncashment, removeMyEncashment, clearLeaveCategoryOptions, clearLeaveBalance } = encashmentSlice.actions;

export default encashmentSlice.reducer;
